import React, { useEffect } from 'react'
import classes from './MyStudents.module.css'
import { Grid } from '@chakra-ui/react'
import MyStudentsTable from '../../components/MyStudentsTable/MyStudentsTable'
import MyStudentsFilters from '../../components/MyStudentsFilters/MyStudentsFilters'
import { useStudentsStore } from '../../store/studentsStore'
import UmSpinner from '../../components/UI/UmSpinner'

function MyStudents() {
    const [fetchPurchaseTags, fetchCommunicationTypes, fetchOnboardingStatuses] = useStudentsStore(
        state => [state.fetchPurchaseTags, state.fetchCommunicationTypes, state.fetchOnboardingStatuses]
    )
    const studentsLoading = useStudentsStore(state => state.studentsLoading)

    useEffect(() => {
        fetchPurchaseTags()
        fetchCommunicationTypes()
        fetchOnboardingStatuses()
    }, [])

    return (
        <Grid className={classes.container} id='mystudents-body'>
            <MyStudentsFilters />
            {
            studentsLoading
            ?
            <UmSpinner />
            :
            <div className={classes.table}>
                <MyStudentsTable />
            </div>
            }
        </Grid>
    )
}

export default MyStudents
